import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight, FaWater } from "react-icons/fa";
import { PiMountains } from "react-icons/pi";
import { BsTree } from "react-icons/bs";
import { VscCompass } from "react-icons/vsc";
import "./ApplyHero.css";

const HEADLINE = ["Your Journey", "Begins Here."];
const RAIL_ICONS = [PiMountains, BsTree, FaWater, VscCompass];
const ease = [0.22, 1, 0.36, 1];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const lineUp = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.85, ease } },
};
const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease, delay } },
});

export default function ApplyHero({ onBegin }) {
  return (
    <section className="aph" id="apply-top">
      {/* Background photo */}
      <div className="aph__media" aria-hidden="true">
        <motion.img src="./assets/hero.png" alt="" className="aph__img" initial={{ scale: 1.06, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 1.8, ease }} />
        <div className="aph__scrim" />
      </div>
      {/* Cloud layer */}
      <div className="clouds" aria-hidden="true">
        <img src="./assets/image.png" alt="" />
        <img src="./assets/image.png" alt="" className="cloud-flip" />
      </div>

      <Container fluid="xl" className="aph__inner container-fg container-2xxl">
        {/* Rail */}
        <motion.aside className="hero__rail aph__rail" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.5, ease }} aria-hidden="true">
          <span className="hero__rail-num">01</span>
          <span className="hero__rail-line" />
          <ul className="hero__rail-icons">
            {RAIL_ICONS.map((Icon, i) => (
              <li key={i}>
                <Icon />
                <span className={`hero__rail-line ${i === RAIL_ICONS.length - 1 ? "" : "alt"}`} />
              </li>
            ))}
          </ul>
        </motion.aside>

        {/* Content */}
        <div className="aph__content">
          {/* Eyebrow */}
          <motion.p className="aph__eyebrow u-eyebrow" variants={fadeUp(0.18)} initial="hidden" animate="show">
            Application
          </motion.p>

          {/* Headline — line 1 forest, line 2 rust */}
          <motion.h1 className="aph__title u-display" variants={container} initial="hidden" animate="show">
            {HEADLINE.map((line, i) => (
              <span className="hero__line" key={i}>
                <motion.span className="hero__line-inner" variants={lineUp} style={{ color: i === 1 ? "var(--accent)" : "var(--c-forest)" }}>
                  {line}
                </motion.span>
              </span>
            ))}
          </motion.h1>

          {/* Body copy */}
          <motion.p className="aph__sub" variants={fadeUp(0.62)} initial="hidden" animate="show">
            Forge Retreat is a path to healing and transformation for veterans, first responders, law enforcement, and gold star families. We walk beside you every step of the way.
          </motion.p>

          {/* CTA */}
          <motion.div variants={fadeUp(0.72)} initial="hidden" animate="show">
            <button to="#apply-form" className="aph__cta border-0" onClick={onBegin}>
              Begin Your Application <FaArrowRight className="aph__cta-icon" aria-hidden="true" />
            </button>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}
